import { render, staticRenderFns } from "./PreenrollmentManagement.vue?vue&type=template&id=48b105c2"
import script from "./PreenrollmentManagement.vue?vue&type=script&lang=ts"
export * from "./PreenrollmentManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports